<template>
  <div class="carousel-container">
    <v-carousel
      :show-arrows="false"
      hide-delimiters
      ref="main"
    >
        <v-carousel-item
          v-for="(item, index) in this.model.content"
          :key="index"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
            <display-image class="slide"
                :imageId="item.id"
                :maxWidth="700"
                :max-height="500"
                :contain="true"
            />
        </v-carousel-item>
    </v-carousel>

    <v-row style="margin-top: 20px;">
      <v-col cols="1" style="text-align: end;">
        <i class="fas fa-chevron-left"  @click="goToPrev()"></i>
      </v-col>
      <v-col cols="10">
          <agile class="thumbnails" ref="thumbnails" :options="options2" >
            <div v-for="(slide,index) in this.previewItems" :key="index" :class="`slide--thumbniail slide slide-${index}`"
              @click="goToIndex(index)">
                <display-image
                  :urlPhoto="slide"
                  :maxWidth="150"
                />
            </div>

            <template slot="prevButton">
              <span></span>
            </template>
            <template slot="nextButton">
              <span></span>
            </template>
          </agile>
      </v-col>
      <v-col cols="1" style="text-align: start;">
        <i class="fas fa-chevron-right" @click="goToNext()"></i>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DisplayImage from '../_shared/DisplayImage.vue'
import dataAccess from '../../services/service.data-access'
import { VueAgile } from 'vue-agile'
export default {
  components: { agile: VueAgile, DisplayImage },
  name: 'ContentTypeCarousel',
  props: ['model'],
  data: () => ({
    items: [],
    previewItems: [],
    asNavFor1: [],
    asNavFor2: [],
    options1: {
      dots: false,
      fade: true,
      navButtons: false,
      centerMode: true
    },
    options2: {
      autoplay: false,
      centerMode: true,
      dots: false,
      navButtons: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 5
          }
        },

        {
          breakpoint: 1000,
          settings: {
            navButtons: true
          }
        }
      ]
    }
  }),
  mounted() {
    this.$watch('$refs.thumbnails.currentSlide', async (newValue, oldValue) => {
      for (var index = 0; index <= 3; index++) {
        await this.loadPreviewImages(newValue + index)
      }
      this.$forceUpdate()
    })
  },
  async created() {
    this.previewItems = Array(this.model.content.length).fill('')
    for (let indexR = 0; indexR < this.options2.responsive[0].settings.slidesToShow; indexR++) {
      const imageFile = await dataAccess.getImageFile(this.model.content[indexR].id, 700, 500)
      const srcImg = URL.createObjectURL(imageFile, { type: imageFile.type })
      this.previewItems[indexR] = srcImg
    }
    for (let indexL = this.model.content.length - this.options2.responsive[0].settings.slidesToShow; indexL < this.model.content.length; indexL++) {
      const imageFile = await dataAccess.getImageFile(this.model.content[indexL].id, 700, 500)
      const srcImg = URL.createObjectURL(imageFile, { type: imageFile.type })
      this.previewItems[indexL] = srcImg
    }
    this.$forceUpdate()
  },
  methods: {
    async loadImage(image) {
      const imageFile = await dataAccess.getImageFile(image.id, 150)
      const srcImg = URL.createObjectURL(imageFile, { type: imageFile.type })
      return srcImg
    },
    async loadPreviewImages(index) {
      if (this.previewItems[index] === '') {
        this.previewItems[index] = await this.loadImage(this.model.content[index])
      }
    },

    goToNext() {
      this.$refs.thumbnails.goToNext()
      this.$refs.main.next()
    },
    goToPrev() {
      this.$refs.thumbnails.goToPrev()
      this.$refs.main.prev()
    },
    goToIndex(index) {
      this.$refs.thumbnails.goTo(index)
      this.$refs.main.updateInternalValue(index)
    }
  }

}
</script>
<style lang="scss"  >
.carousel-container{
  max-width: 600px;
  .col-1{
    margin: auto;
    font-size: 25px;
  }
  #image{
  cursor: default;
  }
  i {
    cursor: pointer;
  }
}
.main {
  margin-bottom: 5px;
}
.thumbnails {
  margin: 0 -5px;
  width: calc(100% + 10px)
}
.agile {
  &__nav-button{
    background: transparent;
    border: none;
    color: #ccc;

    font-size: 24px;
    transition-duration: .3s
  }
  .thumbnails {
    position: absolute;

    top: 50%;
    transform: translateY(-50%);

    &--prev{
      left:-45px
    }
    &--next{
      right:-45px
    }
    &:hover{
    color: #888
    }
  }

  &__dot {
    margin: 0 10px;
    button {
      background-color: #eee;
      border: none;
      border-radius: 50%;
      display: block;
      height: 10px;
      font-size: 0;
      line-height: 0;
      margin: 0;
      padding: 0;
      transition-duration: .3s;
      width: 10px;
    }
    &--current,&:hover{
      button{
        background-color: #888
      }
    }
  }
}

.slide{
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  justify-content: center;
  margin: auto;

  &--thumbniail{
    cursor: pointer;
    height: 100px;
    padding: 0 5px;
    transition: opacity .3s;
    &:hover {
      opacity: .75
    }
  }
  img {
    max-height: 100%;
    object-fit: cover;
    object-position: center;
    width: 50%;
  }
}
</style>
